(ns shared.core.utils.date
  (:require ["date-fns" :as d])
  (:refer-clojure :exclude [format compare]))

(defn format
  ([date format-tokens]
   (try (d/format date format-tokens) 
        (catch :default e
          {:error true :message (.-message e)})))
  ([date format-tokens options]
   (try (d/format date format-tokens options) 
        (catch :default e
          {:error true :message (.-message e)}))))

(defn compare
  [date1 date2]
  (d/compareAsc date1 date2))

(defn parse-iso
  [s]
  (d/parseISO s))
